var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeight = function SvgWeight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3v18m-4 0h8M5 7h14M5 7l-3 7c0 1.66 1.34 3 3 3s3-1.34 3-3L5 7Zm14 0-3 7c0 1.66 1.34 3 3 3s3-1.34 3-3l-3-7Z"
  })));
};
export default SvgWeight;